import TextBase from './TextBase'

export default TextBase
